<template>
  <div class="addNewUser f-s-s f-d-c w-100 h-100 p-5">
    <div class="return w-100 f-c-e mb-4">
      <div class="f-c-s returnBtn" @click="returnFunc()">
        <!-- <div class="arrow f-c-c ml-1">&lt;</div> -->
        <div class="returnText f-c-c">برگشت</div>
      </div>
    </div>
    <div class="title f-c-s w-100 mb-4">
      <b-img
        class="title-icon ml-2"
        :src="require(`@/assets/images/gap/folder.svg`)"
      ></b-img>
      <div class="title-text f-c-c">افزودن کاربر جدید</div>
    </div>
    <div
      class="addUserBox f-c-s f-d-c w-100 h-100"
      style="border-top: 1px solid #125488; border-radius: 10px"
    >
      <div class="header f-c-b w-100">
        <div
          v-for="(v, i) in headerItem"
          :key="i"
          class="item f-c-c"
          @click.prevent="activeId = i"
          :class="[activeId == i ? 'active' : '']"
        >
          {{ v }}
        </div>
      </div>
      <div v-if="activeId == 0" class="singleSec f-c-c f-d-c w-100 h-100">
        <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">نام</div>
          <input v-model="name" type="text" />
        </div>
        <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">نام خانوادگی</div>
          <input v-model="family" type="text" />
        </div>
        <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">موبایل</div>
          <input v-model="mobile" type="number" />
        </div>
        <!-- <div class="row f-c-s w-100 mb-3">
          <div class="label f-c-s">ایمیل</div>
          <input v-model="email" type="email" />
        </div> -->
        <div class="row f-c-s w-100 mb-4">
          <div class="label f-c-s">نقش</div>
          <select class="gender" v-model="role">
            <option
              v-for="(v, i) in allRole.information"
              :key="i"
              :value="v.id"
            >
              {{ v.title }}
            </option>
          </select>
        </div>
        <div class="btnSec w-100 f-c-s">
          <div class="finalbtn f-c-c" @click="saveUserSingleFunc()">ذخیره</div>
        </div>
      </div>
      <div v-if="activeId == 1" class="singleSec f-c-c f-d-c w-100 h-100">
        <div class="row f-c-s w-100 mb-5">
          <div class="label f-c-s">عنوان</div>
          <select class="gender" v-model="title">
            <option
              v-for="(v, i) in allUserGroup.user_groups"
              :key="i"
              :value="v"
            >
              {{ v.title }}
            </option>
          </select>
        </div>
        <div class="btnSec w-100 f-c-s">
          <div class="finalbtn f-c-c" @click="saveUserWithGroupFunc()">
            ذخیره
          </div>
        </div>
      </div>
      <div v-if="activeId == 2" class="singleSec f-c-c f-d-c w-100 h-100">
        <div class="dragSection f-c-c w-50 mb-4 h-100">
          <b-form-group
            id="fileInputForum"
            class="dragdrop m-0 f-c-c f-d-c w-100 h-100"
          >
            <b-form-file
              accept=".xlsx, .xls"
              drop-placeholder="رها کنید"
              ref="excel-input"
              @input="addFileFunc"
            >
              <template slot="placeholder">
                <b-img
                  :src="require(`@/assets/images/gap/excel-icon.svg`)"
                ></b-img>
                <div class="text f-c-c">
                  <div class="plus ml-2">+</div>
                  <div class="value f-c-c">
                    {{ "افزودن فایل اکسل" }}
                  </div>
                </div>
              </template>
              <template slot="file-name">
                <b-img
                  :src="require(`@/assets/images/gap/excel-icon.svg`)"
                ></b-img>
                <div class="text f-c-c">
                  <div class="plus ml-2">+</div>
                  <div class="value f-c-c">
                    {{ "افزودن فایل اکسل" }}
                  </div>
                </div>
              </template>
            </b-form-file>
          </b-form-group>
        </div>
        <div class="f-c-c w-100 mb-4">
          <a
            class="sampleExcel f-c-c"
            :href="require(`@/assets/excel/sample_session_user.xlsx`)"
            download
            >دانلود نمونه فایل اکسل</a
          >
        </div>
        <div class="btnSec excelBtn w-100 f-c-c mb-3">
          <div class="finalbtn f-c-c" @click="saveUserWithExcelFunc()">
            ذخیره
          </div>
        </div>
        <div v-if="file && file.name" class="fileList">
          <div class="fileList-item f_c_c">
            <a href="#" class="value">{{ file.name }}</a>
            <span class="close-btn mr-2" @click.prevent="deleteFileFunc()"
              >&times;</span
            >
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import { mapState, mapActions } from "vuex";
export default {
  name: "AddNewUser",
  data() {
    return {
      activeId: 0,
      headerItem: ["تکی", "گروهی", "اکسلی"],
      name: "",
      family: "",
      email: "",
      mobile: "",
      role: "",
      title: "",
      file: {},
      groupUsers: [],
    };
  },
  created() {
    this.getAllUsersGroupFunction({
      user_id: this.user.user_id,
    });
  },
  computed: {
    ...mapState({
      user: (state) => state.gap.user,
      allRole: (state) => state.gap.allRole,
      allUserGroup: (state) => state.gap.allUserGroup,
      sessionStep2Data: (state) => state.gap.sessionStep2Data,
      allGroupUser: (state) => state.gap.allGroupUser,
      excelUser: (state) => state.gap.excelUser,
    }),
  },
  methods: {
    ...mapActions("gap", [
      "getAllUsersGroupFunction",
      "setSessionStep2DataFunction",
      "getGroupUsersFunction",
      "getUserWithExcelFileFunction",
      "setAppTitleFunction",
    ]),
    returnFunc() {
      this.setAppTitleFunction("افزودن جلسه");
      this.$router.push({ name: "addNewSission2" });
    },
    mobileNumber(Number) {
      var IndNum = /^[0]?[789]\d{9}$/;

      if (IndNum.test(Number) && Number.length == 11) {
        return true;
      } else {
        return false;
      }
    },
    validateEmail(email) {
      return email.match(
        /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      );
    },
    saveUserSingleFunc() {
      if (
        this.name == "" ||
        this.mobile == "" ||
        this.role == "" ||
        this.family == ""
      ) {
        this.$bvToast.toast("پر کردن تمام موارد الزامی می باشد.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else if (
        !this.mobileNumber(this.mobile)) {
        this.$bvToast.toast("تلفن همراه را بصورت صحیح وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      } else {
        let newusers = [];
        if (
          Object.keys(this.sessionStep2Data).length &&
          this.sessionStep2Data.users.length
        ) {
          newusers = this.sessionStep2Data.users;
          newusers.push({
            // title: this.name + ' ' + this.family,
            first_name: this.name,
            last_name: this.family,
            // email: this.email,
            mobile: this.mobile,
            role: this.role,
          });
        } else {
          newusers.push({
            // title: this.name + ' ' + this.family,
            first_name: this.name,
            last_name: this.family,
            // email: this.email,
            mobile: this.mobile,
            role: this.role,
          });
        }

        this.setSessionStep2DataFunction({
          users: newusers,
          guest: this.sessionStep2Data.guest,
        });
        this.$router.push({ name: "addNewSission2" });
      }
    },
    saveUserWithGroupFunc() {
      if (this.groupUsers.length) {
        let users = this.sessionStep2Data.users;
        for (let i = 0; i < this.groupUsers.length; i++) {
          users.push({
            first_name: this.groupUsers[i].first_name,
            last_name: this.groupUsers[i].last_name,
            // email: this.groupUsers[i].email,
            mobile: this.groupUsers[i].mobile,
            role: 1573,
          });
        }
        this.setSessionStep2DataFunction({
          users: users,
          guest: this.sessionStep2Data.guest,
        });
        this.$router.push({ name: "addNewSission2" });
      } else {
        this.$bvToast.toast(this.allGroupUser.message, {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      }
    },
    saveUserWithExcelFunc() {
      if (this.file && this.file.name) {
        this.getUserWithExcelFileFunction({
          user_id: this.user.user_id,
          user_group_id: 0,
          excel: this.file,
        });
      } else {
        this.$bvToast.toast("فایل اکسل خود را وارد نمایید.", {
          title: "خطا",
          variant: "danger",
          solid: true,
        });
      }
    },
    addFileFunc(e) {
      if (e) {
        if (this.file && this.file.name) {
          this.$bvToast.toast("تنها مجاز به ارسال یک فایل می باشید.", {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        } else {
          this.file = e;
        }
      }
    },
    deleteFileFunc() {
      this.$refs["excel-input"].reset();
      this.file = {};
    },
  },
  watch: {
    excelUser(n) {
      if (Object.keys(n).length) {
        let newusers = [];
        if (n.code == 100) {
          newusers = this.sessionStep2Data.users;
          for (let i = 0; i < n.users.length; i++) {
            newusers.push({
              first_name: n.users[i].first_name,
              last_name: n.users[i].last_name,
              // email: n.users[i].email,
              mobile: n.users[i].mobile,
              role: n.users[i].role,
            });
          }
          this.setSessionStep2DataFunction({
            users: newusers,
            guest: this.sessionStep2Data.guest,
          });
          this.$router.push({ name: "addNewSission2" });
        } else {
          this.$bvToast.toast(n.message, {
            title: "خطا",
            variant: "danger",
            solid: true,
          });
        }
      }
    },
    allGroupUser(n) {
      if (Object.keys(n).length) {
        if (n.code == 100) {
          this.groupUsers = n.user_group_users;
        } else {
          this.groupUsers = [];
        }
      }
    },
    title(n) {
      this.getGroupUsersFunction({
        user_id: this.user.user_id,
        user_group_id: n.id,
      });
    },
  },
  mounted() {},
};
</script>